<script>
  import AuthenticationRequired from "../../../../components/functional/AuthenticationRequired.svelte";
  import AutoAssemblyProjectPageBase from "../../../../auto-assembly/AutoAssemblyProjectPageBase.svelte";
  import WithAutoAssemblyControlTab from "../../../../auto-assembly/WithAutoAssemblyControlTab.svelte";
  import AutoAssemblyProjectIndexPage from "../../../../auto-assembly/AutoAssemblyProjectIndexPage.svelte";
</script>

<AuthenticationRequired>
  <AutoAssemblyProjectPageBase let:projectId>
    <WithAutoAssemblyControlTab projectId={projectId}>
      <AutoAssemblyProjectIndexPage />
    </WithAutoAssemblyControlTab>
  </AutoAssemblyProjectPageBase>
</AuthenticationRequired>
